// Gerado por scripts/merge-i18n.mjs — não editar à mão.
export const I18N_VERSION = '95e256d0';
